export default __webpack_public_path__ + "static/media/home-vertical-portfolio-img-04.c31a0f1a.jpg";